import React from 'react';

/**
 * Props for the RefreshButton component.
 */
interface RefreshButtonProps {
  onClick: () => void;
  isLoading: boolean;
}

/**
 * A simple button component for refreshing data. It displays a spinning icon
 * when the `isLoading` prop is true.
 * @param {RefreshButtonProps} props - The props for the component.
 * @returns {React.ReactElement} - The rendered refresh button.
 */
const RefreshButton: React.FC<RefreshButtonProps> = ({ onClick, isLoading }) => {
  return (
    <button
      onClick={onClick}
      disabled={isLoading}
      className="p-2 rounded-md bg-white border border-gray-300 text-gray-600 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200 disabled:opacity-50 disabled:cursor-wait"
      aria-label="Refresh tasks"
      title="Refresh tasks"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        // Apply the spin animation only when isLoading is true
        className={`h-5 w-5 ${isLoading ? 'animate-spin' : ''}`}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M4 4v5h5M20 20v-5h-5M4 4l1.5 1.5A9 9 0 0121.5 13.5M20 20l-1.5-1.5A9 9 0 012.5 10.5"
        />
      </svg>
    </button>
  );
};

export default RefreshButton;
